import { get, post } from './client';

export function login({ email, password }) {
  return post('/auth/login', { email, password });
}

export function refresh(refreshToken) {
  return post('/auth/refresh', { refresh_token: refreshToken });
}

export function logout() {
  return post('/auth/logout', {});
}

export function me() {
  return get('/auth/me');
}

